import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { WarningIcon } from "wm-graphics";
import { Button } from "../Button";
import { Modal } from "../Modal";
import { Text } from "../Text";
import { withTranslations } from "../../../utils/withTranslations";
import defaultLocales from "./locales";

import "./Confirm.scss";

class UConfirm extends React.Component {
  static propTypes = {
    /** Additional content to render in the body */
    children: PropTypes.node,
    /** Additional classNames */
    className: PropTypes.string,
    /** Whether Modal is open or not */
    isModalOpen: PropTypes.bool,
    /** Locales object for rendering text */
    locales: PropTypes.object,
    /** Callback function to request the closing of Modal */
    onRequestClose: PropTypes.func,
    /** Callback function when confirm Button is clicked */
    onConfirm: PropTypes.func,
    /** If true renders a warning icon */
    severe: PropTypes.bool,
    /** The type of the modal, set to small for a smaller modal */
    type: PropTypes.string,
    /** Target Id if the onConfirm() requires a parameter */
    confirmValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  onConfirmClick = () => {
    const { confirmValue, onConfirm } = this.props;
    if (onConfirm) {
      if (confirmValue) {
        onConfirm(confirmValue);
      } else {
        onConfirm();
      }
    }
  };

  render() {
    const {
      children,
      className,
      isModalOpen,
      locales,
      onRequestClose,
      severe,
      type,
    } = this.props;
    const confirmClass = classNames("Confirm", type, className);
    return (
      <Modal
        className={confirmClass}
        isModalOpen={isModalOpen}
        onRequestClose={onRequestClose}
      >
        <div className="Confirm__content">
          {severe && (
            <div data-testid="warningIcon">
              <WarningIcon width="50" height="50" />
            </div>
          )}
          <Text type="H5">{locales.confirmMessage}</Text>
          {children && (
            <div className="Confirm__children" data-testid="confirmChildren">
              {children}
            </div>
          )}
        </div>
        <div className="Confirm__footer">
          <Button data-testid="noButton" type="text" onClick={onRequestClose}>
            {locales.no}
          </Button>
          <Button
            data-testid="yesButton"
            type="primary"
            onClick={this.onConfirmClick}
          >
            {locales.yes}
          </Button>
        </div>
      </Modal>
    );
  }
}

const translatedConfirm = withTranslations(defaultLocales)(UConfirm);

export { translatedConfirm as Confirm };

export default translatedConfirm;
